module.exports = __webpack_public_path__ + "img/6.c98acb02.jpg";